<template>
    <form class="mx-auto">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('accommodation.accommodationPlaces')" :showTitle="false"></page-title>

            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>

            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{$t('accommodation.title')}}</div>
                </div>
                <div class="card-body row">
                    <div class="form-group col-md-6">
                        <label class="font-weight-bold">{{ $t('accommodation.name') }}</label>
                        <input type="text" class="form-control" readonly v-model="accommodationPlace.name">
                    </div>
                    <div class="form-group col-md-6">
                        <label class="font-weight-bold">{{ $t('accommodation.nameEN') }}</label>
                        <input type="text" class="form-control" readonly v-model="accommodationPlace.nameEn">
                    </div>
                    <div class="form-group col-md-6">
                        <label class="font-weight-bold">{{ $t('accommodation.type') }}</label>
                        <input type="text" class="form-control" readonly v-model="accommodationPlace.type">
                    </div>
                    <div class="form-group col-md-6">
                        <label class="font-weight-bold">{{ $t('accommodation.category') }}</label>
                        <input type="text" class="form-control" readonly v-model="accommodationPlace.category">
                    </div>
                    <div class="form-group col-md-12">
                        <label class="font-weight-bold">{{ $t('accommodation.url') }}</label>
                        <div class="form-control">
                            <a v-bind:href="accommodationPlace.url">{{accommodationPlace.url}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{$t('address.cardTitle')}}</div>
                </div>
                <div class="card-body">
                    <app-address :address="accommodationPlace.address"></app-address>
                </div>
            </div>
            <div v-if="showContactPerson">
                <div class="card mt-3">
                    <div class="card-header bg-primary text-white">
                        <div class="card-title h5 m-0">{{$t('contactPerson')}}</div>
                    </div>
                    <div class="card-body">
                        <app-person :person="accommodationPlace.contact"></app-person>
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{$t('accommodation.title')}}</div>
                </div>
                <div class="card-body">
                    <app-accommodation :accommodation="accommodationPlace.accommodation"></app-accommodation>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{$t('otherFields.otherFields')}}</div>
                </div>
                <div class="card-body">
                    <otherFields :otherFields="accommodationPlace.otherFields"></otherFields>
                </div>
            </div>
            <div class="mt-3" v-if="accommodationPlace">
                <AuxiliaryRegisterDetails :entryId="accommodationPlace.auxRegisterEntityId"></AuxiliaryRegisterDetails>
            </div>
        </div>
    </form>
</template>

<script>
    import AppAddress from '../../../components/address/AddressDetails';
    import { AccommodationPlaceDetails } from '../../../models/models';
    import AppPerson from '../../../components/person/ContactPersonDetails';
    import AppAccommodation from '../../../components/accommodation/AccommodationDetails';
    import OtherFields from '../../../components/otherFields/OtherFieldsDetails.vue';
    import PageTitle from '../../../components/common/PageTitle';
    import AuxiliaryRegisterDetails from '../../../components/dynamic/AuxiliaryRegisterDetails'

    export default {
        components: {
            'appAddress': AppAddress,
            'appPerson': AppPerson,
            'appAccommodation': AppAccommodation,
            OtherFields,
            PageTitle,
            AuxiliaryRegisterDetails
        },
        props: {
            id: {
                type: Number,
                required: true
            },
            returnUrl: {
                type: String,
                default() {
                    return '';
                }
            }
        },
        data() {
            return {
                accommodationPlace: new AccommodationPlaceDetails(),
                loading: false,
                showContactPerson: false
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            backToRegister() {
                this.$router.push(this.returnUrl || '/registers/accommodationPlaces');
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/accommodationPlace/GetDetails/${this.id}`).then(result => {
                    this.accommodationPlace = new AccommodationPlaceDetails(result.data);
                    if (this.accommodationPlace.contact.firstName !== '') {
                        this.showContactPerson = true;
                    }
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('buttons.load.btnText'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => { this.loading = false; });
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
